import React from 'react'
import { View } from 'react-native'
import { tv } from 'tailwind-variants'

import Chip from '@ui-kit/components/Chip'

import type { RadioSetComponentProps as Props } from './types'

const radioChip = tv({
  slots: {
    container: 'mr-2.5',
  },
  variants: {
    isLast: {
      true: 'mr-0',
    },
  },
})

const RadioChip = (props: Props) => {
  const { container } = radioChip({ isLast: props.isLast })
  return (
    <View className={container()}>
      <Chip
        label={props.label}
        isActive={props.checked}
        onPress={async () => props.onPress(props.value)}
        id={props.testID}
      />
    </View>
  )
}

export default RadioChip
